import React, { Component } from 'react'
import FontAwesome from 'react-fontawesome'

import Option from './Option'
import { QuestionWrapper, QuestionText, QuestionTextSpan, OptionsWrapper, QuestionBackLink, QuestionPlusWrapper, QuestionMinusWrapper, QuestionMinutes, QuestionMinutesLabel } from '../StyledComponents/IntroQuestions/Question'

class MinutesQuestion extends Component {
    constructor(props) {
        super(props)

        this.state = { value: 10 }
        this.handleChange = this.handleChange.bind(this)
        this.decrement = this.decrement.bind(this)
        this.increment = this.increment.bind(this)
    }

    handleChange(event) {
        this.setState({ value: event.target.value })
    }

    decrement() {
        const newValue = Math.max(0, this.state.value - 1)
        this.setState({ value: newValue })
    }

    increment() {
        this.setState({ value: this.state.value + 1 })
    }

    render() {
        const {
            text, onAnswerClicked, onBackClicked, nextQuestion,
        } = this.props

        const option = {
            label: 'Confirm',
            value: this.state.value,
            nextQuestion,
        }

        const backLink = (
            <QuestionBackLink onClick={onBackClicked} >
                <FontAwesome
                    name="arrow-left"
                    size="lg"
                />
            </QuestionBackLink>
        )

        return (
            <QuestionWrapper>
                {backLink}
                <QuestionText marginBottom="60" minHeight="100">
                    <QuestionTextSpan>{text}</QuestionTextSpan>
                </QuestionText>
                <div className="row">
                    <QuestionMinusWrapper className="col" onClick={this.decrement}>
                        <FontAwesome
                            name="minus"
                            size="3x"
                            style={{ color: this.state.value === 0 ? '#ccc' : 'var(--fai-text-color)' }}
                        />
                    </QuestionMinusWrapper>
                    <QuestionMinutes className="col">
                        {this.state.value}
                    </QuestionMinutes>
                    <QuestionPlusWrapper className="col" onClick={this.increment}>
                        <FontAwesome
                            name="plus"
                            size="3x"
                        />
                    </QuestionPlusWrapper>
                </div>
                <QuestionMinutesLabel className="col">
                    minutes
                </QuestionMinutesLabel>
                <OptionsWrapper>
                    <Option
                        data={option}
                        fullWidth={false}
                        onOptionClicked={onAnswerClicked}
                    />
                </OptionsWrapper>
            </QuestionWrapper>
        )
    }
}

export default MinutesQuestion



// WEBPACK FOOTER //
// ./src/components/IntroQuestions/MinutesQuestion.js